import { defineMessages } from 'react-intl-next';

const _default_1: {
    readonly deactivatedCreatorName: {
        readonly id: "rovo-chat.agent-card.deactivated-name";
        readonly defaultMessage: "{name} (deactivated)";
        readonly description: "Name of the agent creator when it is deactivated";
    };
} = defineMessages({
    deactivatedCreatorName: {
        id: 'rovo-chat.agent-card.deactivated-name',
        defaultMessage: '{name} (deactivated)',
        description: 'Name of the agent creator when it is deactivated',
    },
} as const);
export default _default_1;
